import React, { useState, useEffect, useRef, useMemo } from "react";
import InputBox from "../../components/InputBox";
import { WPDropDownMenu } from "../../packages/WPDropDownMenu/WPDropDownMenu.jsx";
import {
  getPredictLimits,
  getPredictionData,
  getPredictionStatus,
  predictionCalculation,
  getWordReport,
  getadvanceSettings,
} from "../../network/cipAPI";
import WPTertiaryButton from "../../packages/WPTertiaryButton";
import PageLoading from "../../components/PageLoading";
import BoxCompontent from "../../components/BoxComponent";
import { useDispatch, useSelector } from "react-redux";
import {
  storeForcastWindow,
  storePredictionData,
  storeAdvancedSettings,
} from "../../Store/TemplateStore/template.action";
import CriticalDeleteDialog from "../../components/CriticalDeleteDialog";
import { TextFieldValidator } from "../../components/InputBox/TextFieldValidator";
import AgTable from "../../components/AgTable";
import { dateFormatter } from "../../utils/tableDataFormatter";
import createNotification, {
  ERROR_NOTIFICATION,
} from "../../components/Notifications";
import { NotificationManager } from "react-notifications";

import moment from "moment";
import PopoverText from "../../components/PopoverText";
import InfoIconGreen from "../../assets/info-icon-green.svg";
import { AccordionDownIcon } from "../../packages/SVGs";
import { createDownloadMenuItems } from "../../common/configs/downloadMenuConfig";
import {
  getSortedData,
  typeFormatter,
  multipleReasonFormatter,
} from "../../utils/tableDataFormatter";
import exportAllTables from "../../XLSDownload/ExportAllTables/index.js";
import ExportAllData from "./exportAllData";
import {
  fetchSuggestedSettings,
  formatSuggestedSettings,
  isNullOrUndefinedOrEmpty,
} from "../../utils/Utils";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { API_URLS } from "../../network/appUrls";
import WPLoader from "../../packages/WPLoader/WPLoader.jsx";
import { DIALOG_TYPES } from "../../packages/ConfirmationPopup/index.js";
import ConfirmationPopup from "../../packages/ConfirmationPopup/index.js";
import {
  CustomModalButtons,
  CIP_MISSING_VALIDATION,
  STATUS_API_ERROR_KEYS,
} from "../../constants/global.constants.js";
import { getBenefitsInfo, getOptimizationTargetKey } from "./predictUtils.js";
import { generateFileName } from "../../utils/Utils.js";
import "./index.css";
import IconWithTooltip from "../../common/styles/components/headings/IconWithTooltip.js";
import IconButton from "../../packages/IconButton";
import { QuestionIcon, SettingsIcon } from "../../assets/icons";
import CustomModal from "../../packages/CustomModal";
import WPButton from "../../packages/WPButton/index.jsx";
import WPInputLabel from "../../packages/WPInputLabel/WPInputLabel.jsx";
import WPAgGrid from "../../packages/WPAgGrid/WPAgGrid";
import StatusApiErrorDialog from "../../components/StatusAPIErrorDialog";
import AdvancedSettings from "../analyseData/AdvancedSettings/AdvancedSettings.jsx";

const PredictCIP = ({ setDisableNextButton, setSettingsButton }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const intervalIdRef = useRef(null);
  const comparisonGridRef = useRef(null);
  const [forecastDays, setForecastDays] = useState(
    useSelector((state) => state.forecastWindow),
  );
  const [isSettingsDialogOpen, setIsSettingsDialogOpen] = useState(false);
  const [limitWindow, setLimitWindow] = useState(null);
  const [showValidationWarning, setShowValidationWarning] = useState(false);
  const [predictionData, setPredictionData] = useState(
    useSelector((state) => state.predictionData),
  );
  const [isOutSideRange, setIsOutsideRange] = useState(false);
  const [isOutsideSoftLimit, setIsOutsideSoftLimit] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [rowData, setRowData] = useState(null);
  const [errorMsgFailedPrediction, setErrorMsgFailedPrediction] =
    useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [processedPercentage, setprocessedPercentage] = useState(false);
  const [showOverlayLoader, setShowOverlayLoader] = useState(false);
  const [taskId, setTaskId] = useState(null);
  const [showPredictData, setShowPredictData] = useState(false);
  const [isWordDownloading, setIsWordDownloading] = useState(false);
  const [helpDialogOpen, setHelpDialogOpen] = useState(false);
  const [isNoStablePointsDialogOpen, setIsNoStablePointsDialogOpen] =
    useState(false);
  const [isNoPredictedCipsDialogOpen, setIsNoPredictedCipsDialogOpen] =
    useState(false);
  const {
    selTrain: selectedTrain,
    volume: volumeUnit,
    pressure: pressureUnit,
    flow: flowUnit,
    permeate_quality: permeateQualityUnit,
    currency,
    foulingType,
    advancedSettings: { optimization_target },
  } = useSelector((state) => state);

  const currentYear = useMemo(() => new Date().getFullYear(), []);

  const handleSettingsDialogOpen = () => {
    setIsSettingsDialogOpen(true);
  };

  const handleSettingsDialogClose = () => {
    setIsSettingsDialogOpen(false);
  };

  const onHelpBtnClick = () => {
    setHelpDialogOpen(true);
  };

  useEffect(() => {
    setSettingsButton?.(
      <WPTertiaryButton
        onClick={handleSettingsDialogOpen}
        disabled={isLoading}
        label={t("analyseData.settings")}
        icon={<SettingsIcon />}
        iconPlacement="before"
        size="medium"
        variant="outlined"
      />,
    );

    return () => setSettingsButton?.(null);
  }, [isLoading]);

  const handleSettingsSave = () => {
    // If prediction data already exists, rerun the prediction with new settings
    if (predictionData && forecastDays) {
      // Clear existing task ID to force a new calculation
      setTaskId(null);
      // Trigger new prediction
      callPredict();
    }
  };

  const downloadFileName = useMemo(
    () => generateFileName(t("predictionStrings.cleaningAdvisorReport")),
    [t],
  );

  const dispatch = useDispatch();

  const getIndex = (params, column) => {
    return column ? params.node.rowIndex + 1 : "";
  };

  const formatDate = (params, date) => {
    return date ? dateFormatter(params) : "";
  };

  const handleValidationWarningClose = (buttonId) => {
    setShowValidationWarning(false);
    // Clear any existing notifications
    NotificationManager.removeAll();

    if (buttonId === CustomModalButtons.CANCEL) {
      callPredict(true);
    } else if (buttonId === CustomModalButtons.CONFIRM) {
      // Preserve existing query parameters
      const currentParams = window.location.search;
      navigate(`${API_URLS.basePath}analyseData${currentParams}`, {
        state: { showRecurrent: true },
      });
    }
  };
  const colDef = [
    {
      headerName: t("predictionStrings.predictedSchedule"),
      headerClass: "my-css-class",
      children: [
        {
          headerName: t("predictionStrings.index"),
          field: "predictedItem.index",
          valueGetter: (params) =>
            getIndex(params, params.data.predictedItem.start_date),
          flex: 1,
        },
        {
          headerName: t("predictionStrings.type"),
          field: "predictedItem.type",
          valueFormatter: (params) => typeFormatter(params, t),
          sortable: true,
          flex: 1,
        },
        {
          headerName: t("predictionStrings.startDate"),
          field: "predictedItem.start_date",
          sortable: true,
          flex: 1.5,
          valueFormatter: (params) =>
            formatDate(params, params.data.predictedItem.start_date),
        },
        {
          headerName: t("predictionStrings.reason"),
          field: "predictedItem.reason",
          sortable: true,
          flex: 2,
          wrapText: true,
          autoHeight: true,
          valueFormatter: (params) =>
            multipleReasonFormatter(params.data.predictedItem.reason),
          valueGetter: (params) =>
            multipleReasonFormatter(params.data.predictedItem.reason),
        },
      ],
    },
    {
      headerName: t("predictionStrings.recommendedSchedule"),
      headerClass: "my-css-class",
      children: [
        {
          headerName: t("predictionStrings.index"),
          field: "recommendedItem.index",
          valueGetter: (params) =>
            getIndex(params, params.data.recommendedItem.start_date),
          flex: 1,
        },
        {
          headerName: t("predictionStrings.type"),
          field: "recommendedItem.type",
          sortable: true,
          valueFormatter: (params) => typeFormatter(params, t),
          flex: 1,
          minWidth: 160,
        },
        {
          headerName: t("predictionStrings.startDate"),
          field: "recommendedItem.start_date",
          sortable: true,
          flex: 1.5,
          valueFormatter: (params) =>
            formatDate(params, params.data.recommendedItem.start_date),
        },
        {
          headerName: t("predictionStrings.reason"),
          field: "recommendedItem.reason_recommended",
          sortable: true,
          flex: 2,
          wrapText: true,
          autoHeight: true,
          valueFormatter: (params) =>
            multipleReasonFormatter(
              params.data.recommendedItem.reason_recommended,
            ),
          valueGetter: (params) =>
            multipleReasonFormatter(
              params.data.recommendedItem.reason_recommended,
            ),
        },
      ],
    },
  ];

  const comparisonColDef = useMemo(
    () => [
      {
        headerName: "",
        field: "comparisonMetric",
        flex: 2.2,
        sortable: false,
      },
      {
        headerName: t("predictionStrings.predictedCipSchedule"),
        children: [
          {
            headerName: t("predictionStrings.minShort"),
            field: "predictedMin",
            flex: 1,
            sortable: false,
            headerClass: "left-divider",
            cellClass: "left-divider",
          },
          {
            headerName: t("predictionStrings.maxShort"),
            field: "predictedMax",
            flex: 1,
            sortable: false,
          },
        ],
      },
      {
        headerName: t("predictionStrings.recommendedCipSchedule"),
        children: [
          {
            headerName: t("predictionStrings.minShort"),
            field: "recommendedMin",
            flex: 1,
            sortable: false,
            headerClass: "left-divider",
            cellClass: "left-divider",
          },
          {
            headerName: t("predictionStrings.maxShort"),
            field: "recommendedMax",
            flex: 1,
            sortable: false,
          },
        ],
      },
      {
        headerName: t("predictionStrings.lifetimeThreshold"),
        headerGroupClass: "lifetime-threshold-group-header",
        flex: 1.3,
        sortable: false,
        children: [
          {
            headerName: "",
            flex: 1.3,
            field: "lifetimeThreshold",
            sortable: false,
            headerClass: "left-divider lifetime-threshold-empty-header",
            cellClass: "left-divider",
          },
        ],
      },
    ],
    [t],
  );

  const financialBenefits = {
    energy_saving: t("predictionStrings.energySaving"),
    chemical_saving: t("predictionStrings.chemicalSaving"),
    downtime_saving: t("predictionStrings.downtimeSaving"),
    increased_production: t("predictionStrings.waterProduction"),
  };

  const annualBenefits = {
    annual_energy_saving: t("predictionStrings.energySaving"),
    annual_chemical_saving: t("predictionStrings.chemicalSaving"),
    annual_downtime_saving: t("predictionStrings.downtimeSaving"),
    annual_increased_production: t("predictionStrings.waterProduction"),
  };

  const formatComparisonValue = (value) => {
    if (isNullOrUndefinedOrEmpty(value)) {
      return "-";
    }

    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) {
      return String(value);
    }

    return numericValue.toFixed(2);
  };

  const getMetricRange = (rangeData, aliases = []) => {
    for (const alias of aliases) {
      if (rangeData?.[alias]) {
        return rangeData[alias];
      }
    }
    return {};
  };

  const getThresholdValue = (thresholds, aliases = []) => {
    for (const alias of aliases) {
      const value = thresholds?.[alias];
      if (!isNullOrUndefinedOrEmpty(value)) {
        return value;
      }
    }
    return null;
  };

  const comparisonMinMaxRows = useMemo(() => {
    if (!predictionData) {
      return [];
    }

    const predictedMinMax = predictionData?.predicted_min_max || {};
    const optimizedMinMax = predictionData?.optimized_min_max || {};
    const failureThresholds = predictionData?.failure_thresholds || {};

    const metricsConfig = [
      {
        rowLabel: `${t("predictionStrings.feedPressure")} (${pressureUnit || "-"})`,
        aliases: ["feed_pressure"],
        thresholdAliases: ["max_feed_pressure", "feed_pressure"],
        thresholdType: "max",
      },
      {
        rowLabel: `${t("predictionStrings.pressureDrop")} (${pressureUnit || "-"})`,
        aliases: ["dp_raw", "pressure_drop"],
        thresholdAliases: ["max_pressure_drop", "pressure_drop", "dp_raw"],
        thresholdType: "max",
      },
      {
        rowLabel: `${t("predictionStrings.permeateFlow")} (${flowUnit || "-"})`,
        aliases: ["permeate_flowrate", "permeate_flow"],
        thresholdAliases: ["min_permeate_flow", "permeate_flowrate"],
        thresholdType: "min",
      },
      {
        rowLabel: `${t("predictionStrings.permeateConductivity")} (${permeateQualityUnit || "-"})`,
        aliases: ["permeate_quality"],
        thresholdAliases: ["max_permeate_quality", "permeate_quality"],
        thresholdType: "max",
      },
    ];

    return metricsConfig.map((metric) => {
      const predictedMetric = getMetricRange(predictedMinMax, metric.aliases);
      const optimizedMetric = getMetricRange(optimizedMinMax, metric.aliases);
      const thresholdRawValue = getThresholdValue(
        failureThresholds,
        metric.thresholdAliases,
      );

      const thresholdTag =
        thresholdRawValue === null
          ? null
          : metric.thresholdType === "min"
            ? t("predictionStrings.minShort")
            : t("predictionStrings.maxShort");
      const thresholdValue =
        thresholdRawValue === null
          ? "-"
          : formatComparisonValue(thresholdRawValue);

      return {
        comparisonMetric: metric.rowLabel,
        predictedMin: formatComparisonValue(predictedMetric?.min),
        predictedMax: formatComparisonValue(predictedMetric?.max),
        recommendedMin: formatComparisonValue(optimizedMetric?.min),
        recommendedMax: formatComparisonValue(optimizedMetric?.max),
        lifetimeThreshold:
          thresholdValue === "-" ? "-" : `${thresholdValue} (${thresholdTag})`,
        thresholdValue,
        thresholdTag,
      };
    });
  }, [flowUnit, permeateQualityUnit, predictionData, pressureUnit, t]);

  const showComparisonMinMaxTable = useMemo(
    () =>
      comparisonMinMaxRows.some(
        (row) =>
          row.predictedMin !== "-" ||
          row.predictedMax !== "-" ||
          row.recommendedMin !== "-" ||
          row.recommendedMax !== "-" ||
          row.lifetimeThreshold !== "-",
      ),
    [comparisonMinMaxRows],
  );

  const comparisonMinMaxExportData = useMemo(
    () =>
      comparisonMinMaxRows.map(
        ({
          comparisonMetric,
          predictedMin,
          predictedMax,
          recommendedMin,
          recommendedMax,
          lifetimeThreshold,
        }) => ({
          comparisonMetric,
          predictedMin,
          predictedMax,
          recommendedMin,
          recommendedMax,
          lifetimeThreshold,
        }),
      ),
    [comparisonMinMaxRows],
  );

  const comparisonTableHeight = useMemo(() => {
    const rowCount = Math.max(comparisonMinMaxRows.length, 1);
    const headerHeight = 80;
    const rowHeight = 52;
    return `${headerHeight + rowCount * rowHeight}px`;
  }, [comparisonMinMaxRows.length]);

  const onForecastDaysChange = (value) => {
    if (value) setForecastDays(parseInt(value));
    else {
      setForecastDays(null);
    }
  };
  const onBackClicked = () => {
    setIsOutsideRange(false);
    setIsLoading(false);
  };

  const hasAnyPredictionRows = (data = []) =>
    Array.isArray(data) &&
    data.some(
      ({ predictedItem, recommendedItem }) =>
        predictedItem?.start_date || recommendedItem?.start_date,
    );
  const checkStatus = async (task_id) => {
    try {
      let id = task_id || taskId;
      let predictionStatus;
      if (id === "" || id === null || id === undefined) {
        predictionStatus = { data: { status: "pending" } };
      } else {
        predictionStatus = await getPredictionStatus(id);
      }

      let { status, processed, error } = predictionStatus?.data || {};

      const isNoStablePointsError =
        error === STATUS_API_ERROR_KEYS.NO_STABLE_POINTS;

      try {
        status = status?.toLowerCase();
        if (status === "completed") {
          if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
          }
          setShowOverlayLoader(false);
          setIsNoStablePointsDialogOpen(false);
          setIsNoPredictedCipsDialogOpen(false);
          setTaskId("");

          const predicitionData = await getPredictionData(
            selectedTrain,
            forecastDays,
          );
          setIsLoading(false);
          setDisableNextButton(false);
          if (predicitionData?.data["modeling"]) {
            const d = predicitionData?.data["modeling"].replaceAll(
              "-Infinity",
              '"-Infinity"',
            );

            const parsedData = JSON.parse(d);

            setPredictionData(parsedData);
            setIsLoading(false);
            setDisableNextButton(false);
            dispatch(storePredictionData(parsedData));
            setErrorMsgFailedPrediction("");
            setprocessedPercentage("");
          }
        } else if (status === "pending") {
          setIsLoading(false);
          setShowOverlayLoader(false);
          if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
          }
          setDisableNextButton(false);
          setprocessedPercentage("");
        } else if (status === "running") {
          setprocessedPercentage(processed);
          setIsLoading(true);
          setShowOverlayLoader(false);
          setDisableNextButton(true);
          setErrorMsgFailedPrediction("");
        } else if (status === "failed") {
          setprocessedPercentage("");
          setShowOverlayLoader(false);
          if (isNoStablePointsError) {
            setErrorMsgFailedPrediction("");
            setIsNoStablePointsDialogOpen(true);
            setIsNoPredictedCipsDialogOpen(false);
          } else {
            setErrorMsgFailedPrediction(
              t("predictionStrings.failedPrediction"),
            );
          }
          setIsLoading(false);
          setDisableNextButton(false);
          if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
          }

          if (!isNoStablePointsError) {
            createNotification(
              ERROR_NOTIFICATION,
              error || t("predictionStrings.failedPrediction"),
              "",
            );
          }

          setTaskId("");
        }
        return status;
      } catch (err) {
        return "failed";
      }
    } catch (err) {
      if (err.code === "ERR_NETWORK" || err.response.status === 502) {
        console.log("Error is " + err);
      } else {
        if (intervalIdRef.current) {
          clearInterval(intervalIdRef.current);
          intervalIdRef.current = null;
        }
        setIsLoading(false);
        setShowOverlayLoader(false);
        setDisableNextButton(false);
        setprocessedPercentage("");
        if (rowData === null)
          setErrorMsgFailedPrediction(t("predictionStrings.errorPrediction"));
        console.log("Error is " + err);
        setTaskId("");
        return "failed";
      }
    }
  };

  useEffect(() => {
    setShowOverlayLoader(true);
    setDisableNextButton(true);
    checkStatus();

    // Cleanup function to clear interval when component unmounts
    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (forecastDays && predictionData) {
      const rowData = [];
      const maxLength = Math.max(
        predictionData["recommended_cip_start_date"].length,
        predictionData["predicted_cip_start_date"].length,
      );

      for (let i = 0; i < maxLength; i++) {
        const recommendedItem = {
          start_date: predictionData["recommended_cip_start_date"][i] || null,
          reason_recommended: predictionData["recommend_cip_reason"][i] || null,
          reason: null,
          type: predictionData["recommended_cip_type"][i] || null,
        };

        const predictedItem = {
          start_date: predictionData["predicted_cip_start_date"][i] || null,
          reason: predictionData["predicted_cip_reason"][i] || null,
          type: predictionData["predicted_cip_types"][i] || null,
        };

        rowData.push({ recommendedItem, predictedItem });
      }
      const sortedData = getSortedData(rowData);
      setRowData(sortedData);

      const hasPredictedRows = hasAnyPredictionRows(sortedData);
      setIsNoPredictedCipsDialogOpen(!hasPredictedRows);
    }
  }, [predictionData]);

  const allData = ExportAllData();

  const benefitsInfo = useMemo(
    () =>
      getBenefitsInfo(
        predictionData,
        optimization_target,
        currency,
        volumeUnit,
        false,
      ),
    [predictionData, optimization_target, currency, volumeUnit],
  );

  const annualBenefitsInfo = useMemo(
    () =>
      getBenefitsInfo(
        predictionData,
        optimization_target,
        currency,
        volumeUnit,
        true,
      ),
    [predictionData, optimization_target, currency, volumeUnit],
  );

  const hasPredictionRows = useMemo(
    () => hasAnyPredictionRows(rowData),
    [rowData],
  );

  const totalBenefitWindow = useMemo(() => {
    if (!limitWindow || !predictionData?.forcast_window) return "";
    return `${moment(limitWindow?.["max_date"]).format(
      "DD/MM/YYYY",
    )} - ${moment(limitWindow?.["max_date"])
      .add("days", predictionData.forcast_window)
      .format("DD/MM/YYYY")}`;
  }, [limitWindow, predictionData?.forcast_window]);

  const annualBenefitWindow = useMemo(() => {
    if (!limitWindow) return "";
    return ` ${moment(limitWindow?.["max_date"]).format(
      "DD/MM/YYYY",
    )} - ${moment(limitWindow?.["max_date"])
      .add("year", 1)
      .format("DD/MM/YYYY")}`;
  }, [limitWindow]);

  const exportAllData = {
    ...allData,
    predictionDataRaw: predictionData,
    predictionandRecommendData: rowData,
    comparisonMinMaxData: comparisonMinMaxExportData,
    totalbenefitWindow: totalBenefitWindow,
    annualBenefitsWindow: annualBenefitWindow,
    benefitsInfo,
    annualBenefitsInfo,
  };

  const callPredict = async (proceedOnMissing = false) => {
    setErrorMsgFailedPrediction(null);
    setIsNoStablePointsDialogOpen(false);
    setIsNoPredictedCipsDialogOpen(false);
    dispatch(storePredictionData(null));
    dispatch(storeForcastWindow(forecastDays));
    setRowData(null);
    setPredictionData(null);
    setIsLoading(true);
    let task_id = taskId;

    try {
      if (!taskId) {
        const calculation = await predictionCalculation(
          parseInt(forecastDays),
          selectedTrain,
          proceedOnMissing,
        );
        task_id = calculation?.data?.task_id;
        setTaskId(task_id);
        if (
          calculation?.status === 400 &&
          calculation?.data?.detail?.key?.includes(
            CIP_MISSING_VALIDATION.ERROR_KEY,
          )
        ) {
          createNotification(
            ERROR_NOTIFICATION,
            calculation?.data?.detail?.error,
            "",
          );
          setShowValidationWarning(true);
        } else if (calculation?.status == 400 || calculation?.status == 422) {
          createNotification(ERROR_NOTIFICATION, calculation?.data?.error, "");
          setIsLoading(false);
          setDisableNextButton(false);
          return;
        }
        // Only start interval if we have a valid task_id
        if (task_id) {
          checkStatus(task_id);
          intervalIdRef.current = setInterval(function () {
            // Always use the captured task_id from closure
            if (task_id) {
              checkStatus(task_id);
            }
          }, 15000);
          setDisableNextButton(true);
          setprocessedPercentage("1%");
        } else {
          setIsLoading(false);
          setDisableNextButton(false);
          setprocessedPercentage("");
        }
      }
    } catch (error) {
      setIsLoading(false);
      setprocessedPercentage("");
    }
  };

  const onPredictClicked = async () => {
    try {
      if (
        forecastDays &&
        parseInt(forecastDays) > parseInt(limitWindow.soft_limit) &&
        parseInt(forecastDays) <= parseInt(limitWindow.hard_limit)
      ) {
        setIsOutsideSoftLimit(true);
        return;
      } else if (forecastDays > limitWindow.hard_limit) {
        setIsOutsideRange(true);
        return;
      } else if (!forecastDays) {
        setErrorMsg(t("predictionStrings.forecastError"));
        return;
      }
      await callPredict();
    } catch (err) {}
  };

  const onProceedClicked = async (value) => {
    setIsOutsideSoftLimit(false);
    if (value.action === "CONFIRM") {
      await callPredict();
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchLimitAndOptimizationTarget = async () => {
      try {
        setShowOverlayLoader(true);
        const limits = await getPredictLimits(selectedTrain);
        if (limits.status === 200 && limits?.data) {
          const { previous_prediction, default_limit } = limits.data;
          setLimitWindow(limits.data);
          // Check for previous_prediction and set forecast window and prediction data if present
          if (previous_prediction) {
            const { forecast_window, modeling } = previous_prediction;
            if (forecast_window) {
              const days = Math.ceil(forecast_window);
              setForecastDays(days);
              dispatch(storeForcastWindow(days));
            }
            if (modeling) {
              const parsedData = JSON.parse(modeling);
              setPredictionData(parsedData);
              dispatch(storePredictionData(parsedData));
            }
          } else {
            // when previous prediction is null
            setPredictionData(null);
            setRowData(null);
            dispatch(storePredictionData(null));
            const days = Math.ceil(default_limit);
            setForecastDays(days);
            dispatch(storeForcastWindow(days));
          }
        } else {
          throw new Error("Failed to fetch prediction limits");
        }

        const advancedSettings = await getadvanceSettings(selectedTrain);
        const { status, data } = advancedSettings;
        if (status === 200 && data) {
          const { settings: response } = data;
          dispatch(storeAdvancedSettings(response));
        } else {
          throw new Error("Failed to fetch advanced settings");
        }
        setShowPredictData(true);
      } catch (err) {
        createNotification(
          ERROR_NOTIFICATION,
          t("ValueStrings.somethingWentWrong"),
          "",
        );
        setShowPredictData(false);
      } finally {
        setShowOverlayLoader(false);
      }
    };

    fetchLimitAndOptimizationTarget();
  }, [selectedTrain]);

  const handleExcelExport = async () => {
    try {
      // Fetch and store suggested settings
      const suggestedSettings = await fetchSuggestedSettings(
        selectedTrain,
        dispatch,
      );

      // Format suggested settings for export
      const suggestedOthers = suggestedSettings
        ? formatSuggestedSettings(suggestedSettings, t)
        : null;

      // Prepare export data with suggested values
      const updatedExportData = {
        ...exportAllData,
        suggestedOthers,
      };

      await exportAllTables(
        downloadFileName,
        updatedExportData,
        foulingType,
        t,
        selectedTrain,
      );
    } catch (err) {
      console.error("Excel export failed", err);
    }
  };

  const handleWordDownload = async () => {
    try {
      setIsWordDownloading(true);
      const response = await getWordReport(selectedTrain);
      if (response.status === 200) {
        const blob = response.data;
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${downloadFileName}.docx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        createNotification(
          ERROR_NOTIFICATION,
          t("predictionStrings.wordReportDownloadFailed"),
          "",
        );
      }
    } catch (err) {
      console.error("Word report download failed", err);
      createNotification(
        ERROR_NOTIFICATION,
        t("predictionStrings.wordReportDownloadFailed"),
        "",
      );
    } finally {
      setIsWordDownloading(false);
    }
  };

  const downloadMenuItems = createDownloadMenuItems(
    t,
    predictionData !== null,
    isLoading,
    handleExcelExport,
    handleWordDownload,
  );

  return (
    <div className="cleaning-predict-page">
      <div className="descriptionText" id="predict-description">
        {t("predictionStrings.predictDescription")}
      </div>
      {isWordDownloading && (
        <WPLoader loadingMsg={t("predictionStrings.generatingWordReport")} />
      )}
      {showOverlayLoader && <PageLoading customHeight={"320px"} />}
      {showPredictData && (
        <>
          <WPInputLabel
            label={t("predictionStrings.forecastWindow")}
            required
          />
          <div className="flex-between-center">
            <div className="flex-ai-center">
              <InputBox
                id="forecast-days"
                value={forecastDays}
                onChange={onForecastDaysChange}
                errorMsg={errorMsg}
                disabled={isLoading}
                hideClearBtn={isLoading}
                validator={TextFieldValidator.NUMBER_ONLY}
              />
              <div className="info-section">
                <WPButton
                  id="predict-button"
                  onClick={onPredictClicked}
                  customClass="margin-left-10"
                  disabled={!forecastDays || isLoading}
                >
                  {t("predictionStrings.predict")}
                </WPButton>
                <IconButton onClick={onHelpBtnClick}>
                  <QuestionIcon />
                </IconButton>
              </div>
              {optimization_target && (
                <div className="info-section">
                  <div className="optimization-target-display">
                    <strong>
                      {t("advanceSettings.optimizationObjective")}:{" "}
                    </strong>
                    <span className="value">
                      {t(
                        `advanceSettings.${getOptimizationTargetKey(
                          optimization_target,
                        )}`,
                      )}
                    </span>
                  </div>
                  <IconWithTooltip
                    label={t("helpInformation.optimizationObjectiveHelp")}
                  />
                </div>
              )}
            </div>
            <div>
              <WPDropDownMenu
                toggle={
                  <div className="predict-download-toggle">
                    {t("predictionStrings.downloadReport")}
                    <AccordionDownIcon />
                  </div>
                }
                disabled={predictionData === null || isLoading}
                customClass="predict-dropdown-tertiary"
                menuItems={downloadMenuItems}
              />
            </div>
          </div>
          {limitWindow && (
            <div className="descriptionText marginTop5" id="recommended-range">
              {t("predictionStrings.recommendedRange")}-{" "}
              {parseInt(limitWindow.soft_limit)},
              {t("predictionStrings.upperLimit")}-{" "}
              {parseInt(limitWindow.hard_limit)}
            </div>
          )}

          {isLoading ? (
            <PageLoading
              customHeight={150}
              iconHeight={"height--100"}
              message={t("ValueStrings.loaderMessage")}
              percentage={processedPercentage}
            ></PageLoading>
          ) : (
            <div>
              <div style={{ display: "flex", marginTop: 10, marginBottom: 10 }}>
                {rowData && (
                  <div style={{ flex: 1 }} id="predict-table">
                    <AgTable
                      rowData={rowData}
                      columnDefs={colDef}
                      domLayout="autoHeight"
                      name={`${t("excelSheetNames.predict")}.csv`}
                    />
                  </div>
                )}
              </div>
              {errorMsgFailedPrediction && (
                <div
                  style={{}}
                  className="errorMsg"
                  id="error-msg-failed-prediction"
                >
                  {errorMsgFailedPrediction}
                </div>
              )}
              {(() => {
                const { show, showPopover, data } = benefitsInfo;
                return (
                  show && (
                    <>
                      <div className="info-section">
                        <div
                          className="bodyMainHeadingText"
                          style={{ color: "teal" }}
                        >
                          {t("predictionStrings.projectedWindow")} - (
                          {totalBenefitWindow})
                        </div>
                        <IconWithTooltip
                          label={t(
                            "helpInformation.totalFinancialBenefitsHelp",
                          )}
                        />
                      </div>
                      <div
                        className="bodyMainHeadingText marginTop10 blackBorder flex-ai-center"
                        id="total-financial-benefits"
                      >
                        <>
                          {t(`predictionStrings.${data.benefitsLabel}`)}
                          {showPopover && (
                            <PopoverText
                              descriptor={
                                <img src={InfoIconGreen} alt="icon" />
                              }
                              descriptionText={t(
                                "predictionStrings.totalBenefitNote",
                              )}
                            />
                          )}
                          : {data.benefitsValue}
                        </>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {Object.entries(financialBenefits).map(
                          ([key, value]) => (
                            <BoxCompontent
                              key={key}
                              title={value}
                              value={predictionData[key + "_dollars"]}
                              percentageValue={predictionData[key + "_percent"]}
                              volume={predictionData[key]}
                              days={predictionData[key + "_days"]}
                              id={`${key}-box-component`}
                            />
                          ),
                        )}
                      </div>
                    </>
                  )
                );
              })()}

              {(() => {
                const { show, showPopover, data } = annualBenefitsInfo;
                return (
                  predictionData?.forcast_window < 365 &&
                  predictionData?.forcast_window > 183 &&
                  show && (
                    <div>
                      <div
                        className="bodyMainHeadingText marginTop10 "
                        style={{ color: "teal" }}
                      >
                        {" "}
                        {t("predictionStrings.projectedAnnualBenefits")} - (
                        {annualBenefitWindow} ){" "}
                      </div>
                      <div
                        className="bodyMainHeadingText marginTop10 blackBorder flex-ai-center"
                        id="total-annual-benefits"
                      >
                        <>
                          {t(`predictionStrings.${data.benefitsLabel}`)}
                          {showPopover && (
                            <PopoverText
                              descriptor={
                                <img src={InfoIconGreen} alt="icon" />
                              }
                              descriptionText={t(
                                "predictionStrings.annualBenefitNote",
                              )}
                            />
                          )}
                          : {data.benefitsValue}
                        </>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {Object.entries(annualBenefits).map(([key, value]) => (
                          <BoxCompontent
                            key={key}
                            title={value}
                            value={predictionData[key + "_dollars"]}
                            percentageValue={predictionData[key + "_percent"]}
                            volume={predictionData[key]}
                            days={predictionData[key + "_days"]}
                            id={`${key}-box-component`}
                          />
                        ))}
                      </div>
                    </div>
                  )
                );
              })()}

              {predictionData &&
                hasPredictionRows &&
                !benefitsInfo.show &&
                !annualBenefitsInfo.show && (
                  <div
                    className="errorMsg margin-top-20 blackBorder"
                    id="no-data-error"
                  >
                    {t("predictionStrings.noData")}
                  </div>
                )}

              {showComparisonMinMaxTable && (
                <div
                  className="ro-card-wrapper prediction-comparison-wrapper"
                  id="prediction-comparison-table"
                >
                  <div className="ro-card-header">
                    <div className="info-section">
                      <div className="teal-heading prediction-comparison-title">
                        {t("predictionStrings.comparisonWithThresholdTitle")}
                      </div>
                    </div>
                  </div>
                  <div className="ro-ag-table prediction-comparison-grid">
                    <WPAgGrid
                      gridRef={comparisonGridRef}
                      rowData={comparisonMinMaxRows}
                      columnDefs={comparisonColDef}
                      tableHeight={comparisonTableHeight}
                      exportFileName={t(
                        "predictionStrings.comparisonWithThresholdTitle",
                      )}
                    />
                  </div>
                </div>
              )}
            </div>
          )}

          {isOutSideRange && (
            <CriticalDeleteDialog
              id="outside-range-error-dialog"
              type="error"
              title={t("predictionStrings.forecastedDays")}
              description={t("predictionStrings.forecastDescription")
                .replace("<forecastDays>", forecastDays)
                .replace("<HardLimit>", parseInt(limitWindow.hard_limit))}
              onDialogClose={onBackClicked}
              cancelBtnText={t("ValueStrings.cancel")}
            />
          )}

          {isOutsideSoftLimit && (
            <CriticalDeleteDialog
              id="outside-soft-limit-warning-dialog"
              type="warning"
              cancelBtnText={t("ValueStrings.cancel")}
              confirmBtnText={t("ValueStrings.proceed")}
              title={t("predictionStrings.proceedConfirmation")}
              description={t("predictionStrings.lowerForecastDescription")
                .replace("<forecastDays>", forecastDays)
                .replace("<HardLimit>", parseInt(limitWindow.soft_limit))}
              onDialogClose={onProceedClicked}
            />
          )}

          {isSettingsDialogOpen && (
            <AdvancedSettings
              isSettingsDialogOpen={isSettingsDialogOpen}
              handleClose={handleSettingsDialogClose}
              selectedTrain={selectedTrain}
              cipPredictionAndRecommendation
              onSave={handleSettingsSave}
            />
          )}

          {showValidationWarning && (
            <ConfirmationPopup
              open={showValidationWarning}
              type={DIALOG_TYPES.WARNING}
              header={t("CIPEvent.missingCIPHeader")}
              description={t(
                "predictionStrings.predictionMissingCIPDescription",
              )}
              onClose={handleValidationWarningClose}
              cancelBtn={t("CIPEvent.missingCIPCancelBtn")}
              confirmBtn={t("predictionStrings.updateSchedule")}
              customBackdrop={true}
            ></ConfirmationPopup>
          )}

          {helpDialogOpen && (
            <CustomModal
              show={helpDialogOpen}
              confirmBtn={t("ValueStrings.okay")}
              width="575px"
              header={t("helpInformation.cipPredictionHelp")}
              onModalClose={() => setHelpDialogOpen(false)}
              size="small"
            >
              <div className="help-dialog-content">
                <div className="help-section">
                  <div className="help-heading">
                    {t("helpInformation.cipPredictionHelpHeading")}
                  </div>
                  <ul className="help-list">
                    <li className="help-list-item">
                      {t("helpInformation.cipPredictionHelpAdjustSettings")}
                      <ul className="help-list">
                        <li className="help-list-item">
                          {t(
                            "helpInformation.cipPredictionHelpIncreaseFouling",
                          )}
                        </li>
                        <li className="help-list-item">
                          {t("helpInformation.cipPredictionHelpLowerThreshold")}
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </CustomModal>
          )}

          {(isNoStablePointsDialogOpen || isNoPredictedCipsDialogOpen) && (
            <StatusApiErrorDialog
              show={isNoStablePointsDialogOpen || isNoPredictedCipsDialogOpen}
              dialogType={
                isNoPredictedCipsDialogOpen
                  ? STATUS_API_ERROR_KEYS.NO_PREDICTED_CIPS
                  : STATUS_API_ERROR_KEYS.NO_STABLE_POINTS
              }
              onClose={() => {
                setIsNoStablePointsDialogOpen(false);
                setIsNoPredictedCipsDialogOpen(false);
              }}
            />
          )}

          {rowData && !isLoading && (
            <div className="ro-disclaimer">
              {t("disclaimer", { currentYear })}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PredictCIP;
